import React from "react";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Col, Grid, Row, FormGroup} from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import {getProducts, setAutocompleteProducts} from "../../../../redux/actions/product";
import ProductGeneralAutosuggest1 from "../../../../app-components/Products/ProductGeneralAutosuggest/ProductGenerateAutosuggest1";
import TrackingService from '../../../../services/TrackingService';
class NomCommercialForm extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            nom: '',
            nom1: ''
        }
        
        this.debounceGetProducts = _.debounce((filters) => this.props.getProducts(filters, true), 1000);
        this.lastResultStatus = null;
    }

    componentDidUpdate(prevProps) {
        // Track when analysis result changes (indicating a new analysis was performed)
        if (prevProps.result !== this.props.result && this.props.result.status !== null) {
            this.trackAnalysisResult();
        }
    }

    trackAnalysisResult = async () => {
        try {
            const isCI = this.props.result.status === 1;
            const analysisId = await TrackingService.trackAnalysis({
                analysisType: 'CONTRAINDICATION',
                medications: [],
                findingsCount: isCI ? 1 : 0,
                findings: [],
                riskLevel: isCI ? 'HIGH' : 'LOW',
                patientContext: {},
                responseTime: 0,
                cacheHit: false
            });
            if (analysisId) {
                await TrackingService.trackSave(analysisId, {
                    name: 'Analyse nom commercial',
                    notes: 'Analyse de compatibilité entre noms commerciaux'
                });
                await TrackingService.trackConsultation(analysisId, 5);
            }
        } catch (e) {}
    };
    setValue = (val, index) => {
        let newState = {};
        newState[index] = val;
        this.setState(newState);
    };
    stateProduct = {
        product : null
    }

    chooseStatus(status){

        switch (status) {
            case null:
                return {bg: "#F5F5F5", col: '#536878' }
                break;
            case 0:
                return {bg: "#FFF5FE", col: '#DC143C' }
                break;
            case 1:
                return {bg: "#FEFEFA", col: '#FF7E00' }
                break;
            case -1:
                return {bg: "#FEFEFA", col: '#03C03C' }
                break;
        
            default:
                break;
        }
    }

    render() {
        return (
            <div className="main-content" >
                <Grid fluid>
                    <Row>
                        <Col sm={12}>
                            <Card
                                content=
                                {
                                    <Grid fluid>
                                        <h3 style={{color:'black', fontSize:'30px'}} className="text-center"><strong>Veuillez renseignez les informations nécessaires pour l'analyse d'interactions médicamenteuses contre-indiquées !</strong></h3>
                                        <Row>
                                            <Col xs={12} sm={6} md={6}>
                                                <FormGroup>
                                                    <ProductGeneralAutosuggest1
                                                        value={this.state.nom}
                                                        onChange={(e) => this.setValue(e.target.value, 'nom')}
                                                        addTag={(val) => {this.props.onChangeProduct({ label: val.nom, value: val._id,nomCommercialContreIndique: val.nomCommercialContreIndique }); this.setState({'nom': val['nom'], 'id': val['_id']})}}
                                                        suggestions={this.props.autocompleteProducts}
                                                        placeholder="Nom commercial"
                                                        clearSuggestions={() => this.props.setAutocompleteProducts([])}
                                                        getSuggestions={(val) => this.debounceGetProducts({nom: val, DCI: '', familleTherapeutique: '', classesPharmacologiques: '', dosage: '', forme: ''})}
                                                        style={{width: '100%'}}
                                                        formControl
                                                        nameColumn="nom"
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col xs={12} sm={6} md={6}>
                                                <FormGroup>
                                                <ProductGeneralAutosuggest1
                                                        value={this.state.nom1}
                                                        onChange={(e) => this.setValue(e.target.value, 'nom1')}
                                                        addTag={(val) => {this.props.onChangeProduct1({ label: val.nom, value: val._id,nomCommercialContreIndique1: val.nomCommercialContreIndique }); this.setState({'nom1': val['nom'], 'id': val['_id']})}}
                                                        suggestions={this.props.autocompleteProducts}
                                                        placeholder="Nom commercial"
                                                        clearSuggestions={() => this.props.setAutocompleteProducts([])}
                                                        getSuggestions={(val) => this.debounceGetProducts({nom: val, DCI: '', familleTherapeutique: '', classesPharmacologiques: '', dosage: '', forme: ''})}
                                                        style={{width: '100%'}}
                                                        formControl
                                                        nameColumn="nom"
                                                    />
                                                    
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Grid>
                                }
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12} >
                            <Card                          
                                content=
                                {
                                    <div className="text-center"  
                                         style={{ height: '100%', backgroundColor: this.chooseStatus(this.props.result.status).bg}}>
                                        <p className="text-center" 
                                           style={{paddingTop: '5%', fontSize: '30px', color: this.chooseStatus(this.props.result.status).col}}>
                                            {this.props.result.data}
                                        </p>
                                    </div>
                                }
                            />
                        </Col>
                    </Row>
                    <div className="text-center">
                        <Button  fill type="submit" bsStyle='info' style={{fontSize:"2rem", borderRadius:"20px"}}>
                            Lancer l'analyse
                        </Button>
                    </div>
                </Grid>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        products: state.products.products,
        loading: state.status.loading,
        autocompleteProducts: state.products.autocompleteProducts
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getProducts: (filter, autocomplete) => {
            dispatch(getProducts(filter, autocomplete));
        },
        setAutocompleteProducts: products => {
            dispatch(setAutocompleteProducts(products));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(NomCommercialForm);
